import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {RecordsStateType} from "../models"

// Selectors
import {selectCurrentApproving, selectRecordApproved} from "../store/selectors"

// Actions
import * as a from "../store/actions"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    currentApproving: selectCurrentApproving(state),
    recordApproved: selectRecordApproved(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    approveRecord: (id: string) => dispatch(a.approveRecordAsync.request(id)),
});

export type WithRecordApproveProps = {
    currentApproving: RecordsStateType["currentApproving"],
    recordApproved: RecordsStateType["recordApproved"],
    approveRecord(id: string): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
